import { render, staticRenderFns } from "./AdminContainer.vue?vue&type=template&id=565d9a01"
import script from "./AdminContainer.vue?vue&type=script&lang=js"
export * from "./AdminContainer.vue?vue&type=script&lang=js"
import style0 from "./AdminContainer.vue?vue&type=style&index=0&id=565d9a01&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports